import { jsx as _jsx } from "react/jsx-runtime";
import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { I18nextProvider, initReactI18next } from 'react-i18next';
import { LanguageCodeStorageKey, SupportedLanguages } from './constants';
import { fallback } from './fallback';
import { I18nContext } from './I18nContext';
const LOG_MISSING_TRANSLATIONS_STORAGE_KEY = 'BB_LOG_MISSING_TRANSLATION_KEYS';
/** Creates a provider for the internationalization context. */
const createI18nProvider = (baseResourceUrl, localResources, customLanguageDetector) => {
    const resources = Object.keys(localResources).reduce((accumulator, languageCode) => {
        accumulator[languageCode] = {
            local: { ...(accumulator[languageCode]?.local ?? {}), ...localResources[languageCode] },
        };
        return accumulator;
    }, fallback);
    const languageDetector = new LanguageDetector();
    if (customLanguageDetector) {
        languageDetector.addDetector(customLanguageDetector);
    }
    i18next
        .use(HttpBackend)
        .use(languageDetector)
        .use(initReactI18next)
        .init({
        backend: {
            loadPath: `${baseResourceUrl}/{{lng}}/{{ns}}.json`,
        },
        fallbackLng: SupportedLanguages.enUS,
        supportedLngs: Object.values(SupportedLanguages),
        detection: {
            order: customLanguageDetector
                ? [
                    'querystring',
                    'cookie',
                    'localStorage',
                    'sessionStorage',
                    customLanguageDetector.name,
                    'htmlTag',
                ]
                : undefined,
            lookupCookie: LanguageCodeStorageKey,
            lookupLocalStorage: LanguageCodeStorageKey,
            lookupSessionStorage: LanguageCodeStorageKey,
        },
        interpolation: {
            escapeValue: false,
        },
        partialBundledLanguages: true,
        parseMissingKeyHandler: (key, defaultValue) => {
            if (window.localStorage.getItem(LOG_MISSING_TRANSLATIONS_STORAGE_KEY) === 'true') {
                // eslint-disable-next-line no-console
                console.warn(`Missing translation key: ${key}`);
            }
            // If provided, return the 'defaultValue' when a missing key is encountered
            if (defaultValue) {
                return defaultValue;
            }
            // Fallback to returning the key
            return key;
        },
        resources,
    });
    return ({ children }) => {
        return (_jsx(I18nContext.Provider, { value: i18next, children: _jsx(I18nextProvider, { i18n: i18next, children: children }) }));
    };
};
export { createI18nProvider };
//# sourceMappingURL=I18nProvider.js.map